var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.519,
    height: 105,
    viewBox: "0 0 104.519 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e87f38;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feed",
    transform: "translate(-393 -2230)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_settings_24px",
    d: "M60.41,39.2a26.4,26.4,0,0,0,.237-3.32,26.406,26.406,0,0,0-.237-3.32l7.149-5.591a1.709,1.709,0,0,0,.407-2.168L61.189,13.079a1.7,1.7,0,0,0-2.067-.745l-8.437,3.388A24.754,24.754,0,0,0,44.96,12.4L43.672,3.423A1.652,1.652,0,0,0,42.012,2H28.459A1.652,1.652,0,0,0,26.8,3.423L25.511,12.4a26.031,26.031,0,0,0-5.726,3.32l-8.437-3.388a1.653,1.653,0,0,0-2.067.745L2.506,24.8a1.67,1.67,0,0,0,.407,2.168l7.149,5.591a26.87,26.87,0,0,0-.237,3.32,26.87,26.87,0,0,0,.237,3.32L2.912,44.793a1.709,1.709,0,0,0-.407,2.168L9.282,58.685a1.7,1.7,0,0,0,2.067.745l8.437-3.388a24.754,24.754,0,0,0,5.726,3.32L26.8,68.341a1.652,1.652,0,0,0,1.66,1.423H42.012a1.652,1.652,0,0,0,1.66-1.423l1.288-8.979a26.031,26.031,0,0,0,5.726-3.32l8.437,3.388a1.653,1.653,0,0,0,2.067-.745l6.776-11.723a1.709,1.709,0,0,0-.407-2.168ZM35.236,47.741A11.859,11.859,0,1,1,47.094,35.882,11.872,11.872,0,0,1,35.236,47.741Z",
    transform: "translate(411.729 2246.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_3d_rotation_24px",
    className: "cls-1",
    d: "M32.731,93.975a45.88,45.88,0,0,1-26.119-37.1H.05A52.474,52.474,0,0,0,52.331,105l2.888-.131L38.55,88.2ZM52.331,0,49.444.131,66.112,16.8l5.819-5.819a45.808,45.808,0,0,1,26.075,37.1h6.563A52.4,52.4,0,0,0,52.331,0Z",
    transform: "translate(392.95 2230)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeed);
export default __webpack_public_path__ + "static/media/feed.1dd095c4dfd9195d8051eff2a4c6e82c.svg";
export { ForwardRef as ReactComponent };